module.exports = __webpack_public_path__ + "img/ruffle front width.4a1289f5.png";